module.exports = __webpack_public_path__ + "img/64.5aa81c63.png";